module.exports = __webpack_public_path__ + "assets/img/4559035976f4f356882d21523066f1f7.svg";